import RestrictionWrapper from "features/auth/restrictionWrapper"
import { AuthenticationStatus } from "types"
import useLayout from "hooks/useLayout"
import useAuth from "hooks/useAuth"
import Avatar from './Avatar'

interface ProfileButtonProps {
    showName?: boolean
    className?: string
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ showName, className }) => {
    const { accountPublicData, isLoadingAccountPublicData } = useAuth()
    const { showDialog, hideSidebar } = useLayout()

    const handleProfileButtonClick = () => {
        showDialog('account')
        hideSidebar()
    }

    return (
        <RestrictionWrapper restrictedTo={AuthenticationStatus.online}>
            <div className="relative select-none">
                <div
                    className={`rounded-md flex flex-row items-center bg-gray-200 ${isLoadingAccountPublicData ? 'cursor-default' : 'cursor-pointer'} ${className ?? ''}`}
                    onClick={isLoadingAccountPublicData ? undefined : handleProfileButtonClick}
                    id='profile-button'
                >
                    <Avatar
                        avatarUrl={isLoadingAccountPublicData ? undefined : accountPublicData?.other.avatarUrl}
                        name={isLoadingAccountPublicData || !accountPublicData?.other.isComplete ? undefined : accountPublicData?.name}
                        hasAvatar={isLoadingAccountPublicData ? false : accountPublicData?.other.hasAvatar}
                        size="md"
                        onClick={isLoadingAccountPublicData ? undefined : handleProfileButtonClick}
                        avatarColor={accountPublicData?.other.avatarColor}
                        fallback={isLoadingAccountPublicData ? '' : undefined}
                    />
                    {showName && (
                        isLoadingAccountPublicData
                            ? <p className="skeleton shortest ml-2 mr-4"></p>
                            : <div className="text-black font-bold pl-2 pr-4">{accountPublicData?.name}</div>
                    )}
                </div>
            </div>
        </RestrictionWrapper>
    )
}

export default ProfileButton
